import { render, staticRenderFns } from "./FileSelectionStep.vue?vue&type=template&id=7473ff4c"
import script from "./FileSelectionStep.vue?vue&type=script&lang=ts"
export * from "./FileSelectionStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports